import {AxiosVue} from '@/AxiosVue';
import {ServicioProxy} from '@/config/enums';
import {AxiosPromise} from 'axios';
import {StringStream} from 'codemirror';

export class configService {
    axios: AxiosVue;

    constructor() {
        this.axios = new AxiosVue(ServicioProxy.Metabase);
    }

    saveEmailAlerts(
        clientId: string,
        email: string,
        active: boolean,
        data_no_autorizado: any
    ): AxiosPromise {
        return this.axios.http.post(
            'Metabase/PostgenericA/control_tower_alerts/saveEmailAlerts',
            {
                clientId: clientId || '',
                email: email || '',
                active_alerts: active || '',
                data_no_autorizado: data_no_autorizado || {
                    active: '',
                    email: '',
                    desde: '',
                    hasta: ''
                },
            }
        );
    }

    saveCustomConfig(data: any): AxiosPromise {
        return this.axios.http.post(
            'Metabase/PostgenericA/control_tower_config/saveCustomConfig',
            data
        );
    }

    saveTimersConfig(data: any): AxiosPromise {
        return this.axios.http.post(
            'Metabase/PostgenericA/control_tower_config/saveTimersConfig',
            data
        );
    }

    getEmailAlerts(clientId: string): AxiosPromise {
        return this.axios.http.post(
            'Metabase/PostgenericA/control_tower_alerts/getEmailAlerts',
            {
                clientId: clientId || '',
            }
        );
    }

    getData(clientId: string): AxiosPromise {
        return this.axios.http.post(
            'Metabase/PostgenericA/control_tower_config/getData',
            {
                clientId: clientId || '',
            }
        );
    }

    getTimerData(clientId: string): AxiosPromise {
        return this.axios.http.post(
            'Metabase/PostgenericA/control_tower_config/getTimerData',
            {
                clientId: clientId || '',
            }
        );
    }
}
